const FieldLevel = Object.freeze({
    ITEM: 'item',
    ORDER: 'order'
});

/* istanbul ignore next */
if (typeof module !== 'undefined' && module.exports) {
    module.exports = FieldLevel;
}
